export default {
      id: "oc-res-suggestsalert-usage",
      viewBox: "0 0 1031 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-suggestsalert",
      toString: function () {
        return this.url;
      }
    }